import React, { useState } from "react";
import QRGenerateButton from "./QRGenerateButton";

function VcardQR() {
  const [input, setInput] = useState("");
  const [showQR, setShowQR] = useState(false);
  const [formError, setFormError] = useState(false);
  const [vcardFirstName, setVcardFirstName] = useState("");
  const [vcardLastName, setVcardLastName] = useState("");
  const [vcardCompany, setVcardCompany] = useState("");
  const [vcardEmail, setVcardEmail] = useState("");
  const [vcardMobile, setVcardMobile] = useState("");
  const [vcardUrl, setVcardUrl] = useState("");
  const [vcardStreet, setVcardStreet] = useState("");
  const [vcardCity, setVcardCity] = useState("");
  const [vcardState, setVcardState] = useState("");
  const [vcardPostcode, setVcardPostcode] = useState("");
  const [vcardCountry, setVcardCountry] = useState("");

  function createVcard() {
    if (vcardFirstName) {
      var QRstring = "BEGIN:VCARD\n";
      QRstring += "N:" + vcardLastName + ";" + vcardFirstName + "\n";
      QRstring += "ORG:" + vcardCompany + "\n";
      QRstring += "EMAIL;PREF;INTERNET:" + vcardEmail + "\n";
      QRstring += "TEL;WORK;VOICE:" + vcardMobile + "\n";
      QRstring +=
        "ADR:" +
        ";;" +
        vcardStreet +
        ";" +
        vcardCity +
        ";" +
        vcardState +
        ";" +
        vcardPostcode +
        ";" +
        vcardCountry +
        "\n";
      QRstring += "URL:" + vcardUrl + "\n";
      QRstring += "END:VCARD";
      setInput(QRstring);
      showQRCode();
      setFormError(false);

      setShowQR(true);
    } else {
      setFormError(true);
      showQRCode(false);
      setShowQR(false);
    }
  }

  function showQRCode() {
    document.getElementById("qrwrap").scrollIntoView({
      behavior: "smooth",
    });
  }
  return (
    <>
      <div className="qr-form">
        <h3>vCard QR Code</h3>
        <p>
          Want to send a contact card easily? make it cool, make a QR vCard
          easily.
        </p>
        <input
          type="text"
          value={vcardFirstName}
          onInput={(e) => setVcardFirstName(e.target.value)}
          name="qrcode_vcard_firstname"
          id="qr_vcard_firstname"
          placeholder="First Name"
        />
        <input
          type="text"
          value={vcardLastName}
          onInput={(e) => setVcardLastName(e.target.value)}
          name="qrcode_vcard_lastname"
          id="qr_vcard_lastname"
          placeholder="Last Name"
        />
        <input
          type="text"
          value={vcardCompany}
          onInput={(e) => setVcardCompany(e.target.value)}
          name="qrcode_vcard_company"
          id="qr_vcard_company"
          placeholder="Company"
        />
        <input
          type="text"
          value={vcardEmail}
          onInput={(e) => setVcardEmail(e.target.value)}
          name="qrcode_vcard_email"
          id="qr_vcard_email"
          placeholder="Email Address"
        />
        <input
          type="text"
          value={vcardMobile}
          onInput={(e) => setVcardMobile(e.target.value)}
          name="qrcode_vcard_mobile"
          id="qr_vcard_mobile"
          placeholder="Mobile Number"
        />
        <input
          type="text"
          value={vcardStreet}
          onInput={(e) => setVcardStreet(e.target.value)}
          name="qrcode_vcard_street"
          id="qr_vcard_street"
          placeholder="House / Street"
        />
        <input
          type="text"
          value={vcardCity}
          onInput={(e) => setVcardCity(e.target.value)}
          name="qrcode_vcard_city"
          id="qr_vcard_city"
          placeholder="City"
        />
        <input
          type="text"
          value={vcardState}
          onInput={(e) => setVcardState(e.target.value)}
          name="qrcode_vcard_state"
          id="qr_vcard_state"
          placeholder="State"
        />
        <input
          type="text"
          value={vcardPostcode}
          onInput={(e) => setVcardPostcode(e.target.value)}
          name="qrcode_vcard_postcode"
          id="qr_vcard_postcode"
          placeholder="Postcode"
        />
        <input
          type="text"
          value={vcardCountry}
          onInput={(e) => setVcardCountry(e.target.value)}
          name="qrcode_vcard_country"
          id="qr_vcard_country"
          placeholder="Country"
        />
        <input
          type="text"
          value={vcardUrl}
          onInput={(e) => setVcardUrl(e.target.value)}
          name="qrcode_vcard_url"
          id="qr_vcard_url"
          placeholder="URL / Website"
        />
        {formError && (
          <div className="errorMessage">Error: Field cannot be blank!</div>
        )}
        <button
          type="button"
          className="contrast"
          onClick={() => {
            createVcard();
          }}
        >
          Generate QR
        </button>
      </div>
      <QRGenerateButton
        QRType="vCard"
        QRValue={input}
        showQR={showQR}
        setInput={setInput}
        setShowQR={setShowQR}
      />
    </>
  );
}

export default VcardQR;
